import RefreshIcon from "../../../background/refresh_icon.png";
import AllInOneIcon from "../../../background/allinine_icon.png";
import CompassIcon from "../../../background/compass_icon.png";


export const moreInfoData = [
    {
        "id": 'what',
        "title": "Что это?",
        "description": "Что такое робот-картограф, объединенный адресный план, как создается и обновляется",
        "link": "./what",
        "img": RefreshIcon
    },
    {
        "id": 'why',
        "title": "Зачем это?",
        "description": "Прикладные задачи и кейсы использования для управления территорией",
        "link": "./why",
        "img": AllInOneIcon
    },
    {
        "id": 'how',
        "title": "Как это работает?",
        "description": "Возможности, геокодирование и обогащение Ваших данных, API, обновления",
        "link": "./how",
        "img": CompassIcon
    },
]